import type { DirectoryEvent, RobotDirectoryConnectionState } from './RobotDirectoryClient';

const LABELS: Record<RobotDirectoryConnectionState, string> = {
  idle: '停止中',
  connecting: '接続中',
  connected: '接続済み',
  reconnecting: '再接続中',
  failed: '接続失敗',
};

export const getDirectoryStatusPresentation = (state: RobotDirectoryConnectionState) => ({
  label: LABELS[state],
  notice: state === 'connected'
    ? null
    : state === 'failed'
      ? 'ロボット一覧を更新できません。現在の接続は維持されています。'
      : `ロボット一覧は${LABELS[state]}です。オンライン表示は最新でない可能性があります。`,
});

export const nextDirectoryLastError = (
  current: string | null,
  update: { state: RobotDirectoryConnectionState } | { event: DirectoryEvent },
): string | null => {
  if ('state' in update) return update.state === 'connected' ? null : current;
  if (update.event.type === 'directorySnapshot') return null;
  if (update.event.type !== 'error') return current;
  return typeof update.event.message === 'string' && update.event.message.length > 0
    ? update.event.message
    : 'Directory でエラーが発生しました';
};
